export const SAVE_PRODUCT_PATH = "/products/save/:id?";
